import React from "react";
import zeptoLogo from "../../images/zeptologo.png";
import quaLogo from "../../images/quabrandlogo.png";
import "./DLA.css";

const dlaPartners = [
  {
    name: "Zepto Finance",
    url: "https://zeptofinance.com/",
    logo: zeptoLogo,
  },
  {
    name: "Qualoan",
    url: "https://qualoan.com/",
    logo: quaLogo,
  },
  {
    name: "FundsBull",
    url: "https://fundsbull.com/",
    logo: "/fundsbull.png",
  },
  {
    name: "Dhanvarshaa",
    url: "https://dhanvarshaa.com/",
    logo: "https://www.google.com/s2/favicons?domain=dhanvarshaa.com&sz=128",
  },
];

const DLA = () => (
  <div className="dla-page">
    <section className="dla-hero">
      <p className="dla-eyebrow">RBI COMPLIANCE</p>
      <h1>Digital Lending Apps</h1>
      <p className="dla-hero-subtitle">
        Click any platform below to visit the website in a new tab.
      </p>
    </section>

    <section className="dla-list-section">
      <div className="dla-list">
        {dlaPartners.map((partner) => (
          <a
            key={partner.url}
            href={partner.url}
            target="_blank"
            rel="noopener noreferrer"
            className="dla-card"
          >
            <div className="dla-card-logo">
              <img src={partner.logo} alt={`${partner.name} logo`} />
            </div>
            <div className="dla-card-info">
              <h2>{partner.name}</h2>
              <p>{partner.url}</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  </div>
);

export default DLA;
